module.exports = __webpack_public_path__ + "img/icon-02.29376b93.png";